import { useNavigate } from 'react-router-dom';
import { sectionPath } from '../siteRoutes';
import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useHotel } from '../context/HotelContext';
import { useLanguage } from '../context/LanguageContext';

const Amenities = () => {
  const navigate = useNavigate();
  const { amenities } = useHotel();
  const { t } = useLanguage();

  return (
    <section id="amenities" className="py-20 bg-white" data-testid="amenities-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-orange-500 font-semibold mb-2 text-sm uppercase tracking-wider">{t('amenitiesSection.eyebrow')}</p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 text-gray-900">{t('amenitiesSection.heading')}</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            {t('amenitiesSection.lead')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {amenities.map((amenity, index) => {
            const Icon = LucideIcons[amenity.icon] || LucideIcons.Star;
            return (
              <div 
                key={index} 
                className="text-center group hover:transform hover:-translate-y-2 transition-all duration-300"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-orange-100 to-orange-50 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:from-orange-500 group-hover:to-orange-600 transition-all shadow-md group-hover:shadow-xl">
                  <Icon size={36} className="text-orange-500 group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">{amenity.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{amenity.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-orange-600 rounded-3xl p-12 text-center text-white shadow-2xl">
          <h3 className="text-3xl lg:text-4xl font-bold mb-4">{t('amenitiesSection.ctaTitle')}</h3>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-orange-50">
            {t('amenitiesSection.ctaLead')}
          </p>
          <button
            onClick={() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); else navigate(sectionPath('contact', window.location.pathname)); }}
            className="bg-white text-orange-500 px-10 py-4 rounded-full font-bold text-lg hover:bg-orange-50 transition-all shadow-lg hover:shadow-xl inline-flex items-center gap-2"
            data-testid="amenities-cta-button"
          >
            {t('amenitiesSection.ctaButton')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Amenities;